/**
 * @desc 平台店铺-新增
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformShopResponseDto>;
export function request(
  body: defs.basics.PlatformShopRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformShop/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
